import { render, staticRenderFns } from "./PopSecede.vue?vue&type=template&id=574e063a"
import script from "./PopSecede.vue?vue&type=script&lang=js"
export * from "./PopSecede.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports